import "./Header.css";
import logo from "../../assets/images/logo.png";

function Header({ toggleSidebar }) {

  const admin = JSON.parse(localStorage.getItem("admin")) || null;

  const handleLogout = () => {
    localStorage.removeItem("admin");
    window.location.href = "/admin/login";
  };

  return (
    <div className="header">

      <div className="header-left">
  <button
    className="menu-btn"
    onClick={toggleSidebar}
  >
    ☰
  </button>

  <img
    src={logo}
    alt="logo"
    className="header-logo"
  />
</div>

      <div className="header-right">

        <span className="admin-text">
          {admin?.name ? `Welcome ${admin.name}` : "Welcome Admin"}
        </span>

        {/* ✅ Sirf admin check karo — token nahi */}
        {admin ? (
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        ) : (
          <button
            className="logout-btn"
            onClick={() => window.location.href = "/admin/login"}
          >
            Login
          </button>
        )}

      </div>
    </div>
  );
}

export default Header;